import { Tooltip as AntdTooltip } from 'antd';

export const Tooltip = ({ children, ...props }) => {
    return (
        <AntdTooltip
            classNames={{
                root: 'mi',
            }}
            {...props}
        >
            {children}
        </AntdTooltip>
    );
};
